var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.001,
    height: 36.001,
    viewBox: "0 0 36.001 36.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-phone",
    "data-name": "Icon awesome-phone",
    d: "M1.307,1.73,8.62.042a1.7,1.7,0,0,1,1.934.977l3.375,7.875a1.683,1.683,0,0,1-.485,1.969L9.182,14.351A26.059,26.059,0,0,0,21.642,26.81l3.488-4.261a1.686,1.686,0,0,1,1.969-.485l7.875,3.375a1.708,1.708,0,0,1,.984,1.941L34.27,34.692A1.687,1.687,0,0,1,32.624,36,32.622,32.622,0,0,1,0,3.375,1.685,1.685,0,0,1,1.307,1.73Z",
    transform: "translate(0.001 0.001)",
    fill: "#e3e3e3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneAlt);
export default __webpack_public_path__ + "static/media/phoneAlt.33cd9a6f268c2c198f669b8575765d9c.svg";
export { ForwardRef as ReactComponent };